module.exports = __webpack_public_path__ + "components/app-store/static/s10-05585721a567b4f18cc86f552b42307c.jpg";